 import React from "react";
import { Link } from "react-router-dom";
import bannerImg from "../assets/banner.jpg"; 
import "./Banner.css";

const Banner = () => {
  return (
    <section
      className="banner"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${bannerImg})`,
        height: "85vh",
        display: "flex",
        alignItems: "center",
        padding: "0 60px",
        color: "white",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }}
    >
      <div className="banner-content">
        <p> Together we can protect nature 🌍, preserve our environment, and create a cleaner, greener future for everyone.</p>
        
        <div className="banner-buttons">
          <Link to="/campaign">
            <button className="btn-primary">Create Campaign</button>
          </Link>
          
          <Link to="/report">
            <button className="btn-secondary">Report an Issue</button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Banner;